import Organizations from "../views/Organizations.vue";
import OrganizationCard from "../views/OrganizationCard.vue";
import OrganVlastiCard from "../views/OrganVlastiCard.vue";
import organizationWrapper from "@/modules/organization/components/organizationWrapper";

export const routes = [
  {
    path: "/organizations",
    name: "organizationWrapper",
    component: organizationWrapper,
    children: [
      {
        path: "",
        name: "Organizations",
        component: Organizations
      },
      {
        path: ":action/:id",
        name: "cardOrganization",
        component: OrganizationCard
      },
      {
        path: "/organVlasti/:action/:id",
        name: "cardOrganVlasti",
        component: OrganVlastiCard
      }
    ]
  }
];
